import React from 'react';
import clsx from 'clsx';

interface Props {
	formik: any;
	fieldName: string;
	additionClass?: string;
}

export const ErrorContainer = (props: Props): React.ReactElement => {
	const { formik, fieldName, additionClass } = props;

	return (
		<>
			{
				formik.touched[fieldName] && formik.errors[fieldName] && (
					<div className={clsx(additionClass)}>
						<div className="text-danger fs-8">{formik.errors[fieldName]}</div>
					</div>
				)
			}
		</>
	);
};
